import {
  CHANGE_CASE,
  CHANGE_SWAP_CASE_SEARCH,
  DEFAULT_CASE,
  ERROR,
} from './actions'

export default function (state = {
  search: '',
  case: [],
  page: 0,
  error: false,
}, action) {
  switch (action.type) {
    case CHANGE_CASE:
      return { ...state, case: [...state.case, ...action.payload] }
    case DEFAULT_CASE:
      return { ...state, case: [] }
    case CHANGE_SWAP_CASE_SEARCH:
      return { ...state, search: action.payload }
    case ERROR:
      return { ...state, error: action.payload }
    default:
      return state
  }
}
